import { useState, useEffect } from 'react'
import axios from 'axios'
import AdminClases from './AdminClases'
import SalaVideo from './SalaVideo'
import SalaGrabacion from './SalaGrabacion'

const API = process.env.REACT_APP_API_URL

// Pantalla separada para el rol "Admin" (se entra por el link secreto
// ?admin=1 en Login.jsx, igual que en EspañolGo). La opcion de rol en el
// login es solo para decidir a que pantalla ir; el permiso real se
// verifica aqui contra la base de datos (columna usuarios.es_admin),
// asi que entrar con ?admin=1 sin tener esa columna en true no basta.
export default function PanelAdmin({ usuario, onLogout }) {
  const [estado, setEstado] = useState('verificando') // 'verificando' | 'autorizado' | 'denegado'
  const [claseEnVideo, setClaseEnVideo] = useState(null) // id de la clase cuya sala de video esta abierta, o null
  const [seccion, setSeccion] = useState('clases') // 'clases' | 'grabacion'

  useEffect(() => {
    if (!usuario?.id) { setEstado('denegado'); return }
    axios.get(`${API}/progreso/estadisticas/${usuario.id}`)
      .then(r => setEstado(r.data.es_admin ? 'autorizado' : 'denegado'))
      .catch(() => setEstado('denegado'))
  }, [usuario])

  // La sala de video toma toda la pantalla, sin el encabezado del admin.
  if (claseEnVideo) {
    return <SalaVideo usuario={usuario} claseId={claseEnVideo} onSalir={() => setClaseEnVideo(null)} />
  }

  const PESTANAS = [
    { id: 'clases', ic: '📚', label: 'Clases' },
    { id: 'grabacion', ic: '🎤', label: 'Sala de grabacion' },
  ]

  return (
    <div style={{ minHeight: '100vh', background: '#F8FAFF', fontFamily: 'system-ui, sans-serif' }}>
      <header style={{ background: 'linear-gradient(90deg, #0D1F52, #1B3A8C)', padding: '14px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', color: '#fff' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 22 }}>🛠</span>
          <div>
            <div style={{ fontWeight: 800, fontSize: 15 }}>EnglishBridge · Admin</div>
            <div style={{ fontSize: 11, opacity: .7 }}>{usuario?.email}</div>
          </div>
        </div>
        <button onClick={onLogout}
          style={{ background: 'rgba(255,255,255,0.12)', border: 'none', color: '#fff', padding: '8px 16px', borderRadius: 8, fontFamily: 'inherit', fontSize: 13, cursor: 'pointer' }}>
          🚪 Cerrar sesion
        </button>
      </header>

      <div style={{ padding: '28px 20px' }}>
        {estado === 'verificando' && (
          <div style={{ textAlign: 'center', padding: 60, color: '#6B7280' }}>Verificando acceso...</div>
        )}

        {estado === 'denegado' && (
          <div style={{ maxWidth: 460, margin: '60px auto', textAlign: 'center', background: '#fff', border: '1px solid #E2E6F0', borderRadius: 14, padding: 32 }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🔒</div>
            <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 8, color: '#1A1A2E' }}>Acceso restringido</h2>
            <p style={{ fontSize: 13, color: '#6B7280', marginBottom: 20 }}>
              Tu cuenta ({usuario?.email}) no tiene permisos de administrador.
            </p>
            <button onClick={onLogout}
              style={{ padding: '10px 20px', background: '#1B3A8C', color: '#fff', border: 'none', borderRadius: 10, fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              Cerrar sesion
            </button>
          </div>
        )}

        {estado === 'autorizado' && (
          <>
            <div style={{ display: 'flex', gap: 8, marginBottom: 20, borderBottom: '1px solid #E2E6F0' }}>
              {PESTANAS.map(p => (
                <button key={p.id} onClick={() => setSeccion(p.id)}
                  style={{
                    padding: '10px 18px',
                    border: 'none',
                    background: 'transparent',
                    borderBottom: seccion === p.id ? '3px solid #1B3A8C' : '3px solid transparent',
                    color: seccion === p.id ? '#1B3A8C' : '#6B7280',
                    fontWeight: seccion === p.id ? 800 : 600,
                    fontSize: 14,
                    fontFamily: 'inherit',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                  }}>
                  <span>{p.ic}</span> {p.label}
                </button>
              ))}
            </div>

            {seccion === 'clases' && <AdminClases usuario={usuario} onIniciarClase={setClaseEnVideo} />}
            {seccion === 'grabacion' && <SalaGrabacion usuario={usuario} />}
          </>
        )}
      </div>
    </div>
  )
}
